import { LeanFormSchema } from '../types/config-form.types';

export const SYS_TIME_FORM: LeanFormSchema = {
  version: '2.0.0',
  id: 'sys-time-settings',
  name: 'SystemTime',
  sections: [{
    id: 'sys-time',
    labelKey: 'sysTimeConfig',
    registerTable: 'V3SysTimeConfig',
    fields: [{
      registerKey: 'SysTimeConfig_Control',
      key: 'SysTime_Trigger',
      fieldType: 'trigger',
      labelKey: 'updateSysTime',
      triggerValue: 1,
      customTriggerHandler: 'sysTimeUpdate',
      constraint: { label: 'updateSysTime' },
    }],
  }],
};
